import { useEffect, useContext } from 'react';
import './LandingPage.scss';

// Context
import { LanguageContext } from '../../context/LanguageContext.jsx';

// Components
import ColabCard from '../../components/ColabCard/ColabCard.jsx';
import OpenPageSection from '../../components/OpenPageSection/OpenPageSection.jsx';

// Layout & Sections
import DefaultLayout from '../../layout/DefaultLayout/DefaultLayout.jsx';
import NewsSlider from '../../sections/NewsSlider/NewsSlider';
import ServicesSection from '../../sections/ServicesSection/ServicesSection.jsx';
import About from '../../sections/About/About.jsx';

// Thirdy party components & CSS
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import "swiper/css/navigation";
import Aos from 'aos';
import 'aos/dist/aos.css';

// Logos
import clientsLogos from '../../data/clients.js';
import { upperPartners, lowerPartners } from '../../data/partners.js';

// Data
import colabs from '../../data/colabs.js';
import banners from '../../data/banners.js';
import HorizontalCard from '../../components/HorizontalCard/HorizontalCard.jsx';

// Suporte 
import {textoPortugues, textoIngles } from '../../data/suportText.js';

// PROPDI
import propdi from '../../data/propdi/propdi.js';

function LandingPage() {
  let { languageIndex } = useContext(LanguageContext);

  useEffect(() => {
    Aos.init({
      offset: 200,
      duration: 500,
      easing: 'ease-in-sine',
      once: true
    });
  }, []);

  let desktop_banners = banners.map(b => ({
    img: !languageIndex ? b.ptBR : b.eng,
    reference: b.reference
  }));

  // Titles according to the current language
  let collaboratorsTitle = !languageIndex ? 'Profissionais Colaboradores' : 'Company Partners';
  let clientsTitle = !languageIndex ? 'Clientes' : 'Clients';
  let partnersTitle = !languageIndex ? 'Parceiros' : 'Our Competence Partners';
  let suportText = !languageIndex ? textoPortugues : textoIngles;

  return (
    <DefaultLayout>
      <Swiper
        navigation={true}
        centeredSlides={true}
        modules={[Navigation, Autoplay]}
        autoplay={{ delay: 3700, disableOnInteraction: false }}
        className="mySwiper banner-slider"
      >
        {desktop_banners.map((banner, index) => (
          <SwiperSlide key={index} >
            <div className="banner-wrapper">
              <img src={banner.img} alt="" />

              <a
                href={banner.reference}
                target="_blank"
                rel="noopener noreferrer"
                className="banner-img-rights"
              >
                Imagem de Freepik
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {!languageIndex && (
        <NewsSlider />
      )}

      <ServicesSection />

      <HorizontalCard
        titulo={suportText.titulo}
        texto={suportText.texto}
      />

      <HorizontalCard
        titulo={propdi.title}
      >
        {propdi.content}
      </HorizontalCard>

      <div className='clients'>
          <h2>{ clientsTitle }</h2>
          <div className='clients-row'>
            {clientsLogos.map(logo =>
              <img src={logo} alt='logo do cliente' className='client-logo'/>
            )}
          </div>
      </div>

      <div className="partners">
        <h2 className='section-title'>{ partnersTitle }</h2>
        <div className='partners-rows'>
            <div className='upper-partners'>
              {upperPartners.map(partner =>
                <a href={partner.link} target='_blank' rel='noreferrer'>
                  <img src={partner.image} alt={partner.alt} className='partner-logo'/>
                </a>
              )}
            </div>
            <div className='lower-partners'>
              {lowerPartners.map(partner =>
                <a href={partner.link} target='_blank' rel='noreferrer'>
                  <img src={partner.image} alt={'logo da ' + partner.alt} className='partner-logo' id={partner.alt}/>
                </a>
              )}
            </div>
        </div>
      </div>

      <div className="collaborators">
        <h2 className='section-title'>{ collaboratorsTitle }</h2>
        <div className='colab-cards-holder'>
        {colabs.map((item) => {
          return (
            <ColabCard
              key={item.name}
              img={item.img}
              name={item.name}
              link={item.linkedIn}
            />
          );
        })}
        </div>
      </div>

      <About />

      <OpenPageSection
        text={!languageIndex ? 'Descubra soluções para sua empresa.' : "Discover solutions for your company."}
        btnText={!languageIndex ? 'Saiba mais' : "Learn more"}
        btnLink='/sobre'
        backgroundColor='#B32929'
      />

      <OpenPageSection
        text={!languageIndex ? 'Vamos trabalhar juntos!' : "Let's work together!"}
        btnText={!languageIndex ? 'Entre em contato' : "Contact us"}
        btnLink='/contatos'
        backgroundColor='#F0F0F0'
      />

    </DefaultLayout>
  )
}

export default LandingPage;
